module.exports = __webpack_public_path__ + "assets/54ded6408aa8cd9ddccc008214d6b679.eot";